<template lang="pug">
div
  el-card(shadow='hover').espacamento
    app-header-dados-processo(
      :processo="processo",
      :isCCR="isCCR"
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow="hover").espacamento
    div.cardHeader
      b Dados do DAR:
    div#line
    div.center
      el-col(:span='8').flex
        app-display(label="Prestação (PMT):", :content="parcela.numero", :contentAlignRight="true")
        app-display(label="Data de Emissão:", :content="parcela.boleto.dataEmissao", :contentAlignRight="true")
        app-display(label="Valor da Parcela:", :content="parcela.valorFormatado", :contentAlignRight="true")
        app-display(label="Total de Correção Anual:", :content="parcela.correcaoFormatada", :contentAlignRight="true")
      el-col(:span='8').flex
        app-display(label="Número do DAR:", :content="parcela.boleto.numeroDar", :contentAlignRight="true")
        app-display(label="Data de Vencimento:", :content="parcela.dataVencimentoFormatada", :contentAlignRight="true")
        app-display(label="Total de Juros:", :content="parcela.jurosFormatado", :contentAlignRight="true")
        app-display(label="Valor total do DAR:", :content="parcela.valorFormatado", :contentAlignRight="true")
</template>

<script>
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppDisplay from '@/components/AppDisplay'

export default {
  components: {
    AppHeaderDadosProcesso,
    AppDisplay
  },

  props: {
    processo: {
      type: Object,
      required: true
    },

    parcela: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      active: 0,
      isCCR: false,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.espacamento {
  margin-top: 3%;
  margin: 20px;
  border-radius: 10px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}

.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}

.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/VisualizarDar.vue